import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa87cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner__inner row items-center text-brown-10" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorBanner',
  props: {
    message: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createBlock(_component_q_banner, {
    class: _normalizeClass(["banner bg-red-1", { 'banner--dense': _ctx.$attrs.dense !== undefined }]),
    rounded: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_icon, {
          class: "icon absolute-top-left q-mr-sm",
          color: "negative",
          name: "error",
          size: _ctx.$attrs.dense !== undefined ? 'sm' : 'md'
        }, null, 8, ["size"]),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.message), 1)
        ])
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})